document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".ingredient-display__item");
  const infoContainer = document.querySelector(".ingredient-display__info-item");

  items.forEach(item => {
    item.addEventListener("click", function () {
      items.forEach(i => i.classList.remove("active"));
      this.classList.add("active");

      const image = this.dataset.image;
      const title = this.dataset.title;
      const content = this.dataset.content;

      infoContainer.innerHTML = `
        ${image ? `<div class="ingredient-display__info-item-image"><img src="${image}" width="100%" height="auto" alt="ingredient-img" loading="lazy" /></div>` : ""}
        <p class="section-description ingredient-display__info-item-title">${title}</p>
        <p class="section-description ingredient-display__info-item-content">${content}</p>
      `;
    });
  });
});